<template>
  <footer class="main-footer fl-wrap">
    <div class="footer-inner fl-wrap">
      <div class="container">
        <div class="row">
          <!-- footer widget-->
          <div class="col-md-3">
            <div class="footer-widget fl-wrap">
              <div class="footer-widget-title fl-wrap">
                <h4>Kodi Kenya</h4>
              </div>
              <p>
                Welcome to Kodi Kenya. We are a property management solution suitable for small, medium and large scale
                property management software solution.
                Kodi is the quickest way to live. We provide tenants with a safe way to find houses and property
                managers a seamless to manage their properties.
              </p>
              <div class="fw_hours fl-wrap">
                <span>Monday - Friday:<strong> 8am - 6pm</strong></span>
                <span>Saturday - Sunday:<strong> 9am - 3pm</strong></span>
              </div>
            </div>
          </div>
          <!-- footer widget end-->
          <!-- footer widget-->
          <div class="col-md-3">
            <div class="footer-widget fl-wrap">
              <div class="footer-widget-title fl-wrap">
                <h4>Helpful links</h4>
              </div>
              <ul class="footer-list fl-wrap">
                <li><a href="/about-us">About Our Company</a></li>
                <li><a href="/pricing">Pricing Plans</a></li>
                <li><a href="/contact-us">Contacts</a></li>
                <li><a href="/faq">Help Center</a></li>
              </ul>
            </div>
          </div>
          <!-- footer widget end-->
          <!-- footer widget-->
          <div class="col-md-3">
            <div class="footer-widget fl-wrap">
              <div class="footer-widget-title fl-wrap">
                <h4>Contacts Info</h4>
              </div>
              <ul class="footer-contacts fl-wrap">
                <li><span><i class="fal fa-envelope"></i>
                  Mail :</span>
                  <a href="index2.html#"
                     target="_blank">info@kodi.ke</a>
                </li>
                <li>
                  <span><i class="fal fa-map-marker"></i>Adress :</span>
                  <a href="index2.html#"
                     target="_blank">Nairobi Kenya, Hurlinghum</a>
                </li>
                <li><span><i class="fal fa-phone"></i> Phone :</span><a href="index2.html#">+254(0)772 591 591</a>
                </li>
              </ul>
              <div class="footer-social fl-wrap">
                <ul>
                  <li><a href="https://www.facebook.com/HaooKenya/" target="_blank"><i
                      class="fab fa-facebook-f"></i></a>
                  </li>
                  <li><a href="index2.html#" target="_blank"><i class="fab fa-twitter"></i></a>
                  </li>
                  <li><a href="index2.html#" target="_blank"><i class="fab fa-instagram"></i></a>
                  </li>
                  <li><a href="index2.html#" target="_blank"><i class="fab fa-vk"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
          <!-- footer widget end-->
          <!-- footer widget-->
          <div class="col-md-3">
            <div class="footer-widget fl-wrap">
              <div class="footer-widget-title fl-wrap">
                <h4>Download our APP</h4>
              </div>
              <p>Start working with Kodi that can provide everything you need </p>
              <div class="api-links fl-wrap">
                <a href="/app" class="api-btn color-bg"><i class="fab fa-apple"></i>
                  App Store
                </a>
                <a href="/ios" class="api-btn color-bg"><i class="fab fa-google-play"></i>
                  Play Market
                </a>
              </div>
            </div>
          </div>
          <!-- footer widget end-->
        </div>
      </div>
    </div>
    <!--sub-footer-->
    <div class="sub-footer gray-bg fl-wrap">
      <div class="container">
        <div class="copyright"> &#169; Kodi {{ new Date().getFullYear() }} . All rights reserved.</div>
        <div class="subfooter-nav">
          <ul class="no-list-style">
            <li><a href="https://kodi.ke/terms" target="_blank">Terms of use</a></li>
            <li><a href="https://kodi.ke/privacy-policy" target="_blank">Privacy Policy</a></li>
          </ul>
        </div>
      </div>
    </div>
    <!--sub-footer end -->
  </footer>
</template>

<script>
export default {
  name: "FooterComponent"
}
</script>